'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Modal = require('../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _MarketingModalFooter = require('./MarketingModalFooter');

var _MarketingModalFooter2 = _interopRequireDefault(_MarketingModalFooter);

require('./FullScreenMarketingModal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var FullScreenModal = function FullScreenModal(props) {
    var children = props.children,
        className = props.className,
        header = props.header,
        background = props.background;


    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('FullScreenMarketingModal', className) },
        _react2.default.createElement(
            'div',
            { className: 'modal-positioner',
                style: { backgroundImage: 'url(' + background + ')' } },
            header,
            _react2.default.createElement(
                _Modal2.default,
                props,
                children
            )
        ),
        _react2.default.createElement(_MarketingModalFooter2.default, null)
    );
};

// Styles


// Components


FullScreenModal.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
    header: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]),
    className: _propTypes2.default.string,
    overlay: _propTypes2.default.bool,
    close: _propTypes2.default.func,
    backButtonRoutes: _propTypes2.default.array,
    background: _propTypes2.default.string
};

exports.default = FullScreenModal;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/marketingModalPage/FullScreenMarketingModal.js
// module id = 1921
// module chunks = 0